// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__2CnDR","name":"section_name__26Vw4","post":"section_post__2cRLS","title":"section_title__oWrmH","text":"section_text__JJOaC"};